import { api } from '../core';

/**
 * Retention detail for a single case — the same expiry fields the cases list
 * returns (see `CasesItem`), but keyed by case id and without pagination.
 */
export interface CaseExpiryDatesNode {
  expiryDate: string | null;
  daysUntilExpiry: number | null;
  dateOfFirstUpload: string | null;
  dateOfCaseClosure: string | null;
  expiryReason: string | null;
}

export interface ListCaseExpiryDatesResponse {
  /** Case id -> retention detail, for every case in the current organisation. */
  caseExpiryDates: Record<string, CaseExpiryDatesNode>;
}

const listCaseExpiryDatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getListCaseExpiryDates: builder.query<ListCaseExpiryDatesResponse, void>({
      query: () => ({
        url: `cases/list-case-expiry-dates`,
        method: 'GET',
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetListCaseExpiryDatesQuery } = listCaseExpiryDatesApi;
